module.exports = __webpack_public_path__ + "img/app-store.b1cc9484.svg";